import useSWR from 'swr';

export interface ModuleVisibilityData {
    /** null = the club never configured a list and sees everything. [] = only the always-visible ones. */
    visible: string[] | null;
    profile: string | null;
    profile_applied_at: string | null;
    /** Modules released after the club last applied a profile. */
    new_modules: string[];
    /** Which modules already hold records — drives the confirmation prompt when hiding one. */
    has_data: Record<string, boolean>;
    always_visible: string[];
    available: string[];
    profiles: string[];
}

/**
 * Loads the club's module visibility.
 *
 * ⚠️ While loading, `visible` is undefined and every consumer must treat that as
 * "everything visible" (see isModuleVisible in helpers/clubModules). Defaulting to an
 * empty list instead would make the sidebar render short and then visibly grow.
 *
 * Gated on club membership rather than on `club.settings`, because every backend user
 * needs this to render their navigation.
 */
export const useVisibleModules = (clubSlug?: string, enabled = true) => {
    const { data, error, isLoading, mutate } = useSWR<ModuleVisibilityData>(
        enabled && clubSlug ? `club/${clubSlug}/modules` : null
    );

    return {
        data,
        visible: data?.visible,
        error,
        isLoading,
        mutate
    };
};

export default useVisibleModules;
